import momentKO from 'moment/locale/ko'

const components = {
  momentName: 'ko',
  momentLocale: momentKO
}

const locale = {
  'message': '-',
  'layouts.EmailMarketing': '이메일 마케팅',
  'layouts.riseSuddenlyAndSharply': 'Rise Suddenly And Sharply',
  'layouts.应用市场': '앱 스토어',
  'layouts.易学堂（直播/回放）': '이학당 (생방송/재생)',
  'layouts.直播/回放': '라이브 / 재생',
  'layouts.本服务适合': 'This service is suitable for sellers who have eaby or independent websites',
  'layouts.可打通多平台数据': 'Data from multiple platforms can be connected for user grouping, and private domain traffic can be accurately marketed by email, with an ROI of up to',
  'layouts.application': '응용 프로그램',
  'layouts.current': '사용 중',
  'layouts.去开通': '개통하러 가다',
  'layouts.已开通系统': '시스템이 열려 있습니다',
  'layouts.推荐开通系统': '개통을 추천하는 시스템',
  'layouts.可选择切换导航菜单': '탐색 메뉴를 전환하도록 선택할 수 있습니다',
  'layouts.switch': '{0} 전환',
  'layouts.change': '메뉴는 {0}',
  'layouts.old.version': '왼쪽',
  'layouts.new.version': '상단',
  'layouts.new': '신규 추가',
  'layouts.edit': '편집',
  'layouts.expired': '만료 됨',
  'layouts.upgrade': '업그레이드',
  'layouts.buy': '구입',
  'layouts.onlineservice': '온라인 고객 서비스',
  'layouts.MoneyAssistant': '돈 도우미',
  'layouts.accountSettings': '계정 설정',
  'layouts.usercenter': '사용자 센터',
  'layouts.productPackage': '제품 패키지',
  'layouts.authority': '권한 관리',
  'layouts.store.authorization': '매장 승인',
  'layouts.helpcenter': '도움말 센터',
  'layouts.menusyl': '메뉴 레이아웃',
  'layouts.menusyl.top': '상위 메뉴 레이아웃',
  'layouts.menusyl.left': '사이드 메뉴 레이아웃',
  'layouts.langset': '언어 설정입니다',
  'layouts.menutransformation': '메뉴 변환',
  'layouts.logout': '시스템 종료',
  'layouts.allapplication': '모두 적용',
  'layouts.history': '최근에 열다.',
  'layouts.maylike': '검색하시겠습니까? 아마 메뉴판이 이사한 후의 이름일 것입니다',
  'layouts.customscene': '{0} 사용자 정의 장면',
  'layouts.demo.tips': 'DEMO 환경에서는 이 작업을 지원하지 않으며 자체 계정을 사용하여 해당 기능을 조작할 수 있습니다.',
  'layouts.customscene.currentNoDel': '사용 중인 장면은 삭제가 허용되지 않습니다. 먼저 다른 장면으로 전환한 후 삭제하십시오.',
  'layouts.allmenu': '모든 메뉴',
  'layouts.menusearch': '키워드, 검색 메뉴를 입력하세요',
  'layouts.commonmenu': '자주 사용하는 메뉴',
  'layouts.search.placeholder': '키워드를 입력하여 메뉴를 검색하십시오.',
  'layouts.text.undefined': '데이터가 없습니다.',
  'layouts.operation.guide': '운영 가이드',
  'layouts.bookmarks': '자주 사용하는 기능 즐겨찾기',
  'layouts.bookmarks.success': '컬렉션 추가 성공',
  'layouts.bookmarks.cancel': '컬렉션 취소 성공',
  'layouts.openAll': '원터치 풀온',
  'layouts.manageFavorites': '즐겨찾기 관리',
  'layouts.ViewAll': '모든 기능 보기',
  'layout.searchKeyword': '검색 키워드',
  'layout.error-401': '죄송합니다, 당신은 아직이 기능을 열지 않은, 메뉴 권한을 열 수 있도록 시스템 관리자 계정 소유자에게 문의하시기 바랍니다.',

  'layout.guideLayout.title': '점포 허가',
  'layout.guideLayout.step1': '첫 번째 단계, 귀하의 점포를 바인딩',
  'layout.guideLayout.p1': '점포를 묶은 후, 우리는 즉시 당신의 점포의 상품과 주문을 동기화하기 시작할 것이며, 당신이 시스템에 들어간 후 즉시 업무를 전개할 수 있도록 할 것입니다!',
  'layout.guideLayout.p2': '초보자 안내는 당신만 신속하게 업무를 전개할 수 있고, 시스템에 들어가면 당신은 여전히 다른 점포를 묶을 수 있습니다.',
  'layout.guideLayout.amazon.title': '7일 이내 점포 바인딩, 즉시 2000장 발송',
  'layout.guideLayout.amazon.click': '아마존 점포 바인딩을 클릭하세요',
  'layout.guideLayout.shopify.click': '클릭하여 Shopify 점포 바인딩',
  'layout.guideLayout.temu.click': '클릭하여 TEMU 점포 바인딩',
  'layout.guideLayout.tiktok.click': '클릭하여 Tiktok 점포 바인딩',
  'layout.guideLayout.morePlatform': '더 많은 플랫폼을 기대해주시고...',
  'layout.guideLayout.p3': '클릭',
  'layout.guideLayout.p4': '여기',
  'layout.guideLayout.p5': '프레젠테이션 환경에 들어가서 완전한 기능을 미리 경험하세요!',
  'layout.guideLayout.店铺授权': '점포 허가',
  'layout.guideLayout.bindSuccess': '바인딩 성공',
  'layout.guideLayout.waitText1': '계정에 들어오면 상품 및 주문 데이터를 동기화하기 시작합니다.',
  'layout.guideLayout.waitText2': '예상 소요 시간은 5-30분입니다. 기다려 주십시오.',
  'layout.guideLayout.btnBindMore': '더 많은 점포 바인딩',
  'layout.guideLayout.linkJump': '즉시 진입',

  'version-modal.title': '전환 지침',
  'version-modal.tips': '이 스위치는 현재 버전으로 돌아 가지 않으며 포괄적 인 이해를 위해 새 버전의 도입을 확인할 수도 있습니다.',
  'version-modal.info': 'Easy ERP로 전환하면 다음과 같이 변경됩니다.',
  'version-modal.subInfo-1': '시스템 Ul 변경',
  'version-modal.subInfo-2': '메뉴 순서 변경',
  'version-modal.subInfo-3': '그에 따라 기능이 삭제 및 추가 될 수 있지만 기본 비즈니스 프로세스에는 영향을주지 않습니다.',
  'version-modal.footer': '위의 상황을 이해하고 전환하는 데 동의했습니다.',
  'version-modal.viewDemo': '전망 DEMO',

  'store-tip.title': 'A Sharp weapon for sealing a essential for in vogue goods',
  'store-tip.subtitle': '2 mins fast authorization',
  'store-tip.guide': 'High technology constructing accurate marketing operations',
  'store-tip.info-1': 'Multi-shops management<br>auto anti-associations',
  'store-tip.info-2': 'Live dates updating<br>safe and reliable',
  'store-tip.info-3': 'In time warning for<br>operation risks',
  'store-tip.remind': 'No more reminders for this login',
  'store-tip.btn': 'START AUTHORIZATION',

  'form-modal.cancel': '취소',
  'form-modal.submit': '확인',
  'form-modal.delete': '삭제',
  'form-modal.selected': '선택됨',
  'form-modal.action': '작업',
  'form-modal.third-party-abnormal': '타사 시스템이 비정상입니다!',
  'form-modal.custom.title': '장면 패널 사용자 정의',
  'form-modal.customMenuName': '장면 이름',
  'form-modal.system.title': '사용자 정의 앱 메뉴',
  'form-modal.menuname.placeholder': '사용자 정의 장면 이름을 입력하십시오.',
  'form-modal.remark.placeholder': '비고',
  'form-modal.rule.maxstring': '최대 {0} 문자열 지원',
  'form-modal.rule.maxobject': '최대 {0} 항목 선택',
  'form-modal.rule.select': '{0} 선택하세요',
  'notification-modal.title.prompt': '따뜻한 팁',
  'notification-modal.content.delete.customscene': '복구할 수 없는 장면을 삭제할지 여부',
  'notification-modal.content.maxcustomscene': '최대 30 개의 장면을 만들 수 있습니다. 폐기된 장면을 삭제하거나 기존 장면을 편집할 수 있습니다.',
  'logout.title': '종료 확인',
  'logout.content': '로그아웃을 확인하시겠습니까?',
  'logout.okText': '확인',
  'logout.cancelText': '취소',

  'tabs.close.current': '현재 탭 닫기',
  'tabs.close.right': '오른쪽 닫기',
  'tabs.close.left': '왼쪽 닫기',
  'tabs.close.all': '모두 닫기',

  'station.免费快速建站': 'Free site a construction',
  'station.专属品牌': 'Exclusive brand independent website',
  'station.多渠道': 'Multi-channel & low-price drainage',
  'station.品牌用户': 'Accumulation of brand users',
  'station.用户裂变': 'Users spread growth',
  'station.精细化运营': 'Fine management',
  'station.获取利润': 'Profit maximization',
  'station.一键建站': 'Build a website with one click',

  'station.请填写建站信息': 'Please fill in the relevant information',
  'station.您的建站信息已提交': 'The information has been submitted',
  'station.我们正在加班加点搭建中': 'We are working hard to build your website',
  'station.预计3个工作日内主动联系您': 'It is expected to contact you proactively within 3 working days',
  'station.您也可以通过扫描二维码': 'You can also contact us by scanning the QR code',
  'station.我知道了': 'I see',
  'station.请填写正确的手机号': 'Please fill in the correct phone number',
  'station.请填写正确的邮箱': 'Please fill in the correct email address',
  'station.请填写正确的姓名': 'Please fill in the correct name',
  'station.请使用已授权亚马逊店铺的账号创建独立站': 'Please use the account of an authorized Amazon store to create a website',
  'station.请同意使用刊登系统搭建独立站': 'Please agree to use the listing system to build an independent station',
  'station.请选择一个店铺': 'Please select a shop to create a website',
  'station.目前暂时只支持': 'Only Amazon',
  'station.邮箱': 'Mail',
  'station.联系人姓名': 'Name',
  'station.信息填写无误': 'Verify the information, Build a website for free',
  'station.同意使用刊登系统': 'Agree to use the listing system to build a website',
  'station.为了能更快帮助您创建独立站': 'In order to help you create a website faster, we need to use a listing system.If you have purchased the listing system(old version), we will directly use the system to help you list the product; if you have not purchased the listing system(old version), we will open a 14-day publishing system package for you for free.（https://adv-listing.eccang.com/default/index/login）',

  'EDM.邮件营销': 'EDM',
  'EDM.智能分群': 'Intelligent grouping Recommended',
  'EDM.大数据挖掘': 'Data mining',
  'EDM.千万级发送量': 'Sending volume above tens of millions',
  'EDM.自动化埋点': 'Automated statistics',
  'EDM.快捷邮件制作': 'Quick mail creation',
  'EDM.自动营销风控': 'Automatic marketing risk control',
  'EDM.立即体验': 'Experience Now',

  'empty_data': '현재 읽지 않은 메시지가 없습니다.',
  'authority_account_edit_password': '비밀번호 변경',
  'common_globalcomp_login_again': '재 등록'
}

export default {
  ...components,
  ...locale
}
